import React from 'react';
import { Route, Switch } from 'react-router-dom';
import * as path from './PathConfig';
import PrivateRoute from './PrivateRoute';
import Home from '../components/container/pages/Home';
import Quick from '../components/container/pages/Quick';
import Login from '../components/container/pages/Login';
import QueryCreate from '../components/container/pages/QueryCreate';
import QueryManager from '../components/container/pages/QueryManager';
import ReportCreate from '../components/container/pages/ReportCreate';
import ReportManager from '../components/container/pages/ReportManager';
import Notice from '../components/container/pages/Notice';
import NoticePage from '../components/container/pages/NoticePage';
import NoticeCreate from '../components/container/pages/NoticeCreate';
import ReportEdit from '../components/container/pages/ReportEdit';
import CustomCreate from '../components/container/pages/CustomCreate';
import CustomManager from '../components/container/pages/CustomManager';
import CustomResult from '../components/container/pages/CustomResult'
import SnapshotCreate from '../components/container/pages/SnapshotCreate';
import SnapshotManager from '../components/container/pages/SnapshotManager';
import UserEdit from '../components/container/pages/UserEdit';
import LabelManager from '../components/container/pages/LabelManager';
import Insight from '../components/container/pages/Insight';
import InsightPage from '../components/container/pages/InsightPage';
import SnapshotEdit from '../components/container/pages/SnapshotEdit';
import Privacy from '../components/container/pages/Privacy';
import Stipulations from '../components/container/pages/Stipulations';
import ManagementPolicy from '../components/container/pages/ManagementPolicy';
import Admin from '../components/container/pages/Admin';
import AdminUserEdit from '../components/container/pages/AdminUserEdit';
import TrendVolume from '../components/container/pages/TrendVolume';
import TrendDetail from '../components/container/pages/TrendDetail';


const AuthRouter = () => {
  return (
    <div>
      <Switch>
        <Route exact path={path.DEFAULT} component={Home} />
        <Route path={path.HOME} component={Home} />
        <Route path={path.QUICK} component={Quick} />
        <Route path={path.LOGIN} component={Login} />
        <Route path={path.PRIVACY} component={Privacy} />
        <Route path={path.STIPULATIONS} component={Stipulations} />
        <Route path={path.MANAGEMENTPOLICY} component={ManagementPolicy} />
        <PrivateRoute path={path.QUERYCREATE} component={QueryCreate} />
        <PrivateRoute path={path.QUERYMANAGER} component={QueryManager} />
        <PrivateRoute path={path.REPORTCREATE} component={ReportCreate} />
        <PrivateRoute path={path.REPORTMANAGER} component={ReportManager} />
        <PrivateRoute path={`${path.REPORTEDIT}/:reportID`} component={ReportEdit} />
        <PrivateRoute path={path.CUSTOMREPORTCREATE} component={CustomCreate} />
        <PrivateRoute path={path.CUSTOMREPORTMANAGER} component={CustomManager} />
        <PrivateRoute path={`${path.CUSTOMREPORTRESULT}/:customID`} component={CustomResult} />
        <PrivateRoute path={path.SNAPSHOTCREATE} component={SnapshotCreate} />
        <PrivateRoute path={path.SNAPSHOTMANAGER} component={SnapshotManager} />
        <PrivateRoute path={`${path.SNAPSHOTEDIT}/:snapshotID`} component={SnapshotEdit} />
        <PrivateRoute exact path={path.NOTICE} component={Notice} />
        <PrivateRoute path={`${path.NOTICEPAGE}/:noticeID`} component={NoticePage} />
        <PrivateRoute path={path.NOTICECREATE} component={NoticeCreate} />
        <PrivateRoute path={path.ACCOUNT} component={UserEdit} />
        <PrivateRoute path={path.LABELMANAGER} component={LabelManager} />
        <PrivateRoute exact path={path.INSIGHT} component={Insight} />
        <PrivateRoute path={`${path.INSIGHTPAGE}/:noticeID`} component={InsightPage} />
        <PrivateRoute exact path={path.ADMIN} component={Admin} />
        <PrivateRoute exact path={path.TRENDVOLUME} component={TrendVolume} />
        <PrivateRoute exact path={path.TRENDDETAIL} component={TrendDetail} />
        <PrivateRoute path={`${path.ADMINACCOUNTEDIT}/:userID`} component={AdminUserEdit} />
      </Switch>
    </div>
  )
}

export default AuthRouter;

